import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
  NgZone,
} from '@angular/core';
import { Supplier } from 'src/app/shared/models/supplier.model';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  NgForm,
  Validators,
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SupplierService } from '../supplier.service';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Page } from 'src/app/shared/models/page';
import { Observable } from 'rxjs';
import { MatIconRegistry } from '@angular/material/icon';
import { Location } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { AutoCompleteDataType } from 'src/app/shared/models/settings.model';
import { LocalStoreService } from 'src/app/shared/services/local-store.service';
import { SettingsService } from '../../settings.service';
import { MatDialog as MatDialog } from '@angular/material/dialog';

import { SupplierDialogComponent } from '../supplier-dialog/supplier-dialog.component';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';

@Component({
  selector: 'app-supplier-detail',
  templateUrl: './supplier-detail.component.html',
  styleUrls: ['./supplier-detail.component.css'],
})
export class SupplierDetailComponent implements OnInit {
  //#region Variable Initialization
  title: string = '';
  supplierFormObj: Supplier = <Supplier>{};
  @ViewChild('supplierDetails') supplierForm!: NgForm;
  // TradingAddressForm!: FormGroup;
  isButtonloading: boolean = false;
  searchKeyParams: string = '';
  _selectedCountryCode!: string;
  _selectedRegionCode!: string;
  emailValidationMessage: string[] = [];
  filterFieldCountryNameDisplayFn(_country: AutoCompleteDataType) {
    return _country ? `${_country.name}` : undefined;
  }

  boundGetCountryAutoComplete!: (pageMeta: Page) => Observable<any>;

  redirectRouteCallback!: string | null;
  isAdmin: boolean | undefined;
  //#endregion
  page = new Page();
  isValidateTrue: boolean = false;
  userId: string | null = '0';
  supplierFormData: any;
  isFormSubmitted: boolean = false;
  supplierId: any;
  mpsId: any;
  items!: FormArray;
  emailAddressArray: any = [];
  countryRegions: any = [];
  regionCities: any = [];
  showLoader: boolean = true;
  isAddEdit: boolean = true;
  enableAddButton: boolean = false;
  domainList = [
    'gmail.com',
    'yahoo.com',
    'outlook.com',
    'hotmail.com',
    'aol.com',
    'zoho.com',
    'web.de',
    '126.com',
    '163.com',
    'yeah.net',
  ];
  isUpdateRequest: boolean = false;
  countryList: any;
  constructor(
    public dialog: MatDialog,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private supplierService: SupplierService,
    private settingsService: SettingsService,
    private ls: LocalStoreService,
    private cookieService: CookieService,
    private _location: Location,
    private snack: MatSnackBar,
    private formBuilder: FormBuilder,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private fullLoaderService: FullLoaderService,
    private ngZone: NgZone
  ) {
    iconRegistry.addSvgIcon(
      'add-deck-check',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${environment.assetsLink}images/plus.svg`
      )
    );

    const navigation = this.router.getCurrentNavigation();
    console.log('navigation', navigation);
    if (navigation?.extras?.state) {
      this.mpsId = navigation.extras.state['mpsId'];
    }

    this.supplierFormData = this.formBuilder.group({
      vendorCode: [
        { value: this.mpsId, disabled: true },
        Validators.maxLength(255),
      ],
      vsSupplierCode: [
        { value: null, disabled: true },
        Validators.maxLength(255),
      ],

      companyName: [
        null,
        [
          Validators.required,
          Validators.pattern(/^(?=.*[A-Za-z])[A-Za-z0-9\s,.'-]+$/), // must contain at least one letter and allow dot
        ],
      ],
      firstName: [
        null,
        [Validators.required, Validators.pattern(/^[A-Za-z\s]+$/)],
      ],
      lastName: [
        null,
        [
          Validators.required,
          Validators.maxLength(255),
          Validators.pattern(/^[A-Za-z\s]+$/),
        ],
      ],
      contactPerson: [null, Validators.pattern(/^[A-Za-z\s]+$/)],
      businessRegisterNumber: [null, [Validators.required,Validators.maxLength(255)]],

      state: [null],
      mobileNumber1: [
        null,
        [Validators.required, Validators.pattern(/^\+[1-9]\d{5,14}$/)]
      ],
      mobileNumber2: [null, Validators.pattern(/^\+[1-9]\d{5,14}$/)],
      website: [
        null,
        [
          Validators.required,
          Validators.pattern(
            /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/
          ),
          Validators.maxLength(255),
        ],
      ],
      emailAddressArray: this.formBuilder.array([]),
      isMaker: [null],
      isOwner: [null],
      isAgent: [null],
      // street: ['', Validators.pattern(/^(?=.*[A-Za-z])[A-Za-z0-9\s,'-]+$/)],
      street: [null],
      city: [null, Validators.required],
      region: [null, Validators.required],
      country: [null, Validators.required],
      zipCode: [null],
      // zipCode: [
      //   '',
      //   [
      //     Validators.required,
      //     Validators.pattern(/^\d+$/), // only digits allowed
      //   ],
      // ],
    });
    // Initial set page number and page size
    this.page.pageNumber = 0;
    this.page.size = 10;
  }

  ngOnInit(): void {
    this.showLoader = false;
    this.isAddEdit = history.state.isAddEdit;
    // Try to read cached countries; fallback to fetch if missing
    try {
      const cached = this.ls.getItem('countries');
      this.countryList = cached ? JSON.parse(cached) : [];
    } catch {
      this.countryList = [];
    }

    if (!Array.isArray(this.countryList) || this.countryList.length === 0) {
      this.settingsService.getAllCountriesByFliterKeyValue().subscribe({
        next: (res: any) => {
          this.countryList = Array.isArray(res?.rows) ? res.rows : [];
          try {
            this.ls.setItem('countries', JSON.stringify(this.countryList));
          } catch {}
          this.cdr.markForCheck();
        },
        error: () => {
          this.countryList = [];
        },
      });
    }
    
    this.activatedRoute.paramMap.subscribe((params) => {
      const id = params.get('id');
      this.userId = id;

      if (id === 'all') {
        this.showLoader = false;
      } else {
        this.updateFormPrefill();
      }
    });
    //Check Logged in User is Admin or Not\
    this.isAdmin = JSON.parse(this.cookieService.get('isAdmin'));
    let supplierId: number | any =
      this.activatedRoute.snapshot.paramMap.get('supplierId');

    this.redirectRouteCallback = this.activatedRoute.snapshot.paramMap.get(
      'redirectRouteCallback'
    );
    if (
      supplierId &&
      supplierId !== 'undefined' &&
      typeof supplierId != undefined
    ) {
      // Update Supplier Request
      this.title =
        this.redirectRouteCallback || !this.isAdmin
          ? 'Supplier'
          : 'Update Supplier';
      this.BindForm(supplierId);
    } else {
      this.emailData(0, 'Add');
      this.title = 'Add Supplier';
    }

    if (this.userId !== 'all') {
      this.title = 'Update Supplier';
    }

    console.log(this.supplierFormData.get('vendorCode')?.value);
    this.boundGetCountryAutoComplete =
      this.getCountryFilterKeyDataObservable.bind(this);
  }

  async updateFormPrefill() {
    this.showLoader = true; // Show loader when fetching data

    if (
      this.userId !== 'all' &&
      this.userId !== null &&
      this.userId !== undefined
    ) {
      this.supplierService
        .getSupplierUpdateDataByUserId(this.userId)
        .then((data) => {
          console.log('data to update->',data);
          this.supplierId = data.data[0].supplierid;
          this.isUpdateRequest =
            this.supplierId !== null &&
            typeof this.supplierId !== undefined &&
            this.supplierId > 0;
          const arrayControl = <FormArray>(
            this.supplierFormData.controls['emailAddressArray']
          );

          this.emailAddressArray.controls[0]
            .get('emailAddress')
            .setValue(data.data[0].primaryEmail);
          this.emailAddressArray.controls[0]
            .get('id')
            .setValue(data.data[0].emailId);

          for (let i = 1; i < data.data.length; i++) {
            this.emailData(i, 'Add');
            this.emailAddressArray.controls[i]
              .get('emailAddress')
              .setValue(data.data[i].emailAddresses);
            this.emailAddressArray.controls[i]
              .get('id')
              .setValue(data.data[i].emailId);
          }

          this.onCountrySelected(data.data[0].country);
          this.getCityFilterKeyDataObservable(
            data.data[0].region.iso,
            this._selectedCountryCode
          ).subscribe((data) => {
            this.regionCities = data.rows;
          });

          this.supplierFormData.patchValue({
            companyName: data.data[0].companyName,
            vsSupplierCode: data.data[0].vsSupplierCode,
            vendorCode: data.data[0].mpsVendorCode,
            firstName: data.data[0].firstName,
            lastName: data.data[0].lastName,
            contactPerson: data.data[0].contactPerson,
            businessRegisterNumber: data.data[0].businessRegistrationNumber,
            // address: data.data[0].supplierAddress,
            mobileNumber1: data.data[0].phone1,
            mobileNumber2: data.data[0].phone2,
            street: data.data[0].street,
            city: data.data[0].city.name,
            region: data.data[0].region.iso,

            country: data.data[0].country,

            zipCode: data.data[0].zipcode,
            website: data.data[0].website,
          });
        })
        .catch((error) => {
          // Handle error if the promise rejects
          console.error('Error fetching supplier data:', error);
        })
        .finally(() => {
          // Hide loader after completion (whether success or failure)
          this.showLoader = false;
        });
    }
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      id: 0,
      emailAddress: [null, Validators.required],
      isActive: true,
    });
  }
  /**
   * Fetch supplier details by supplierId and bind supplier form with supplier details
   * @param _supplierId Supplier Id.
   */
  async BindForm(_supplierId: number) {
    this.showLoader = false;
    this.supplierFormObj = await this.supplierService.getSupplierById(
      _supplierId
    );
    if (this.supplierFormObj) {
      this.supplierFormData.patchValue({
        companyName: this.supplierFormObj.companyName || '',
        vendorCode: this.supplierFormObj.vendorCode || '',
        vsSupplierCode: this.supplierFormObj.vsSupplierCode || '',
        firstName: this.supplierFormObj.firstName || '',
        lastName: this.supplierFormObj.lastName || '',
        contactPerson: this.supplierFormObj.contactPerson || '',
        businessRegisterNumber:
          this.supplierFormObj.businessRegisterNumber || '',
        // address: this.supplierFormObj.address || '',
        // country: this.supplierFormObj.countryId || '',
        // state: this.supplierFormObj.stateId || '',
        mobileNumber1: this.supplierFormObj.mobileNumber1 || '',
        mobileNumber2: this.supplierFormObj.mobileNumber2 || '',
        website: this.supplierFormObj.website || '',
        isMaker: this.supplierFormObj.isMaker || '',
        isOwner: this.supplierFormObj.isOwner || '',
        isAgent: this.supplierFormObj.isAgent || '',
        street: [''],
        city: [null, Validators.required],
        region: this.supplierFormObj.region,
        country: [null, Validators.required],

        zipCode: [''],
      });
      this.supplierFormObj.supplierContactAddresses.forEach(
        (element, index) => {
          this.emailData(index, 'Add');
        }
      );
      (this.emailAddressArray?.controls ?? []).forEach(
        (element: any, index: any) => {
          element
            .get('id')
            .setValue(this.supplierFormObj.supplierContactAddresses[index].id);
          element
            .get('emailAddress')
            .setValue(
              this.supplierFormObj.supplierContactAddresses[index].emailAddress
            );
          element
            .get('isActive')
            .setValue(
              this.supplierFormObj.supplierContactAddresses[index].isActive
            );
          if (this.supplierFormObj.supplierContactAddresses[index].isActive) {
            element.get('emailAddress').enable();
          } else {
            element.get('emailAddress').disable();
          }
        }
      );

      // Add initial/first email address control for older data (email not available)
      if (
        this.emailAddressArray == null ||
        typeof this.emailAddressArray == 'undefined' ||
        this.emailAddressArray.length == 0
      ) {
        this.emailData(0, 'Add');
      }
    }
    this.showLoader = false;
  }

  /**
   * Submit supplier form data.
   */
  async SubmitForm() {
    console.log('formvalues', this.supplierFormData.value);
    console.log('formvalid', this.supplierFormData.valid);
    console.log('validate', this.isValidateTrue);

    if (this.supplierFormData.valid) {
      this.isFormSubmitted = true;
      this.isButtonloading = true;
      let formData = this.supplierFormData.getRawValue();
      this.supplierFormObj.companyName = formData.companyName;
      this.supplierFormObj.emailAddress1 =
        formData.emailAddressArray[0].emailAddress;
      // this.supplierFormObj.emailAddress2 = null;
      this.supplierFormObj.businessRegisterNumber =
        formData.businessRegisterNumber;
      // this.supplierFormObj.address = formData.address
      this.supplierFormObj.contactPerson = formData.contactPerson;
      // this.supplierFormObj.countryId = formData.country
      // this.supplierFormObj.stateId = formData.state
      this.supplierFormObj.supplierContactAddresses =
        formData.emailAddressArray;
      this.supplierFormObj.firstName = formData.firstName;
      this.supplierFormObj.isAgent = formData.isAgent;
      this.supplierFormObj.isMaker = formData.isMaker;
      this.supplierFormObj.isOwner = formData.isOwner;
      this.supplierFormObj.lastName = formData.lastName;
      this.supplierFormObj.mobileNumber1 = formData.mobileNumber1;
      this.supplierFormObj.mobileNumber2 = formData.mobileNumber2;
      this.supplierFormObj.vendorCode = formData.vendorCode;
      this.supplierFormObj.vsSupplierCode = formData.vsSupplierCode;
      this.supplierFormObj.website = formData.website;
      this.supplierFormObj.street = formData.street;
      this.supplierFormObj.city = formData.city;
      this.supplierFormObj.region = formData.region;
      this.supplierFormObj.country = formData.country;
      this.supplierFormObj.zipCode = formData.zipCode;
      this.supplierFormObj.zipCode = formData.zipCode;

      this.supplierFormObj.supplierContactAddresses =
        this.supplierFormObj.supplierContactAddresses.map((_address) => {
          _address.id = _address?.id ?? null;
          return _address;
        });
      if (this.isUpdateRequest) {
        this.supplierService
          .updateSupplier(this.supplierId, this.supplierFormObj)
          .then((_supplierDetail) => {
            this.isButtonloading = false;

            this.router.navigateByUrl(
              this.redirectRouteCallback || `/supplier/supplier/updateSupplier`,
              {
                skipLocationChange: this.redirectRouteCallback == null,
              }
            );
            this.closeForm();
          })
          .catch((_httpErrorResponse: HttpErrorResponse) => {
            //console.log(_httpErrorResponse);
            this.isButtonloading = false;
          });
      } else {
        if (this.isValidateTrue) {
          this.supplierService
            .addSupplier(this.supplierFormObj, this.supplierId)
            .then(async (_supplierDetail) => {
              this.isButtonloading = false;
              if (_supplierDetail) {
                let snackBarRef: MatSnackBarRef<any>;
                this.snack.open('User Added Successfully!', 'OK', {
                  duration: 3000,
                });
                this.ngZone.run(() => {
                  snackBarRef = this.snack.open(
                    `User created successfully please copy this password for future login ${_supplierDetail.tempPassword}`,
                    'Copy to Clipboard',
                    { panelClass: 'custom-snack' }
                  );

                  snackBarRef.onAction().subscribe(() => {
                    this.copyToClipboard(_supplierDetail.tempPassword);
                  });
                });
              }

              this.router.navigateByUrl(
                this.redirectRouteCallback || `/supplier/supplier/addSupplier`,
                {
                  skipLocationChange: this.redirectRouteCallback == null,
                }
              );
              this.closeForm();
            })
            .catch((_httpErrorResponse: HttpErrorResponse) => {
              //console.log(_httpErrorResponse);
              this.isButtonloading = false;
            });
        } else {
          this.snack.open(
            'Please validate the supplier emails before creating Supplier profile.',
            'OK',
            { duration: 3000, panelClass: 'custom-snack' }
          );
          this.isButtonloading = false;
        }
      }
    } else {
      this.isButtonloading = false;

      return;
    }
  }

  /**
   * Reset or close supplier form.
   */
  closeForm() {
    // this.router.navigateByUrl(this.redirectRouteCallback || "/supplier/supplier");
    this._location.back();
  }
  addEmailData(i: number) {
    let primaryDomain =
      this.emailAddressArray.controls[0].value.emailAddress.split('@')[1];
    let emailControl =
      this.supplierFormData.getRawValue().emailAddressArray[i].emailAddress;

    if (this.domainList.includes(primaryDomain)) {
      this.enableAddButton = false;
    } else {
      this.enableAddButton = true;
    }

    for (let i = 1; i < this.emailAddressArray.controls.length; i++) {
      const currentEmail =
        this.emailAddressArray.controls[i].value.emailAddress.split('@')[1];
      if (currentEmail !== primaryDomain) {
        this.emailAddressArray.controls[i].get('emailAddress').setValue(null);
        emailControl = null;
        this.snack.open(
          'The email domain must match the first email domain.',
          'OK',
          { duration: 3000, panelClass: 'custom-snack' }
        );
      }
    }

    if (emailControl) {
      // Call the API to check if the email exists in the DB
      this.checkEmailExistence(emailControl, i);
    }

    let duplicate = this.emailAddressArray
      .getRawValue()
      .filter((item: any, index: number) => {
        if (index != i) {
          return (
            item.emailAddress ==
            this.emailAddressArray.controls[i].value.emailAddress
          );
        }
        return false;
      });
    if (duplicate.length > 0) {
      this.snack.open(
        'Duplicate supplier contact email addresses are not allowed',
        'OK',
        { duration: 3000, panelClass: 'custom-snack' }
      );
      this.emailAddressArray.controls[i]
        .get('emailAddress')
        .setValue(
          Object.keys(this.supplierFormObj).length > 0 &&
            this.supplierFormObj?.supplierContactAddresses[i]?.emailAddress
            ? this.supplierFormObj.supplierContactAddresses[i].emailAddress
            : null
        );
      return;
    }
  }

  async checkEmailExistence(email: string, i: number) {
    const data = await this.settingsService.getSearchSupplierEmail(
      i,
      email,
      'supplier'
    );
    if (data && data.validationResult == true) {
      if (this.isUpdateRequest) {
        if (i !== 0) {
          // this.emailValidationMessage[i] = 'This email/domain already exists';
          this.emailAddressArray.controls[i].get('emailAddress').setValue(null);
          this.snack.open('This email/domain already exists', 'OK', {
            duration: 3000,
            panelClass: 'custom-snack',
          });
        }
      } else {
        // this.emailValidationMessage[i] = 'This email/domain already exists';
        this.emailAddressArray.controls[i].get('emailAddress').setValue(null);
        this.snack.open('This email/domain already exists', 'OK', {
          duration: 3000,
          panelClass: 'custom-snack',
        });
      }
    } else {
      this.emailValidationMessage[i] = 'This email/domain is available';
    }
  }

  // to add email,restore or delete email address
  emailData(index: number, type: string, isEdit?: undefined) {
    if (type === 'Delete') {
      if (
        this.emailAddressArray['controls'][index].controls.emailAddress.value ==
          null ||
        this.emailAddressArray['controls'][index].controls.emailAddress.value ==
          ''
      ) {
        const arrayControl = <FormArray>(
          this.supplierFormData.controls['emailAddressArray']
        );
        arrayControl.removeAt(index);
      } else {
        this.emailAddressArray['controls'][index]
          .get('isActive')
          .setValue(false);
        this.emailAddressArray['controls'][index].get('emailAddress').disable();
      }
    } else if (type === 'Restore') {
      this.emailAddressArray['controls'][index].enable();
      this.emailAddressArray['controls'][index].get('isActive').setValue(true);
    } else if (type === 'Add') {
      this.emailAddressArray = this.supplierFormData.get(
        'emailAddressArray'
      ) as FormArray;
      this.emailAddressArray.push(this.createItem());
    }
  }

  checkIfSupplierExists() {
    let formData = this.supplierFormData.getRawValue();
    // const companyName = formData.companyName;
    const emailAddressArr = [];

    for (let emailArrObj of formData.emailAddressArray) {
      if (emailArrObj.isActive) emailAddressArr.push(emailArrObj.emailAddress);
    }
    this.showLoader = false;
    this.supplierService
      .validateSupplierName(emailAddressArr)
      .then((data) => {
        if (
          data.validationResult === false &&
          data.uniquenessResult === false
        ) {
          this.isValidateTrue = true;
        } else {
          const supplierNames: any = [];
          const supplierIdsArr: any = [];

          data.data.map((item: any, index: number) => {
            if (supplierIdsArr.indexOf(item.supplierId) < 0) {
              supplierNames.push({
                companyName: item.companyName,
                supplierId: item.supplierId,
                emailAddress: item.emailAddress,
              });
              supplierIdsArr.push(item.supplierId);
            }
          });

          if (supplierNames.length > 0) {
            const dialogRef = this.dialog.open(SupplierDialogComponent, {
              data: supplierNames,
            });

            dialogRef.afterClosed().subscribe((result) => {
              const selectedSupplierId = result.result.index;
              this.showLoader = true;
              this.supplierService
                .getSupplierUpdateDataByUserId(selectedSupplierId)
                .then((data) => {
                  this.supplierId = data.data[0].supplierid;
                  this.isUpdateRequest =
                    this.supplierId !== null &&
                    typeof this.supplierId !== undefined &&
                    this.supplierId > 0;
                  const arrayControl = <FormArray>(
                    this.supplierFormData.controls['emailAddressArray']
                  );

                  this.emailAddressArray.controls[0]
                    .get('emailAddress')
                    .setValue(data.data[0].primaryEmail);
                  this.emailAddressArray.controls[0]
                    .get('id')
                    .setValue(data.data[0].emailId);

                  for (let i = 1; i < data.data.length; i++) {
                    this.emailData(i, 'Add');
                    this.emailAddressArray.controls[i]
                      .get('emailAddress')
                      .setValue(data.data[i].emailAddresses);
                    this.emailAddressArray.controls[i]
                      .get('id')
                      .setValue(data.data[i].emailId);
                  }

                  this.onCountrySelected(data.data[0].country);
                  this.getCityFilterKeyDataObservable(
                    data.data[0].region.iso,
                    this._selectedCountryCode
                  ).subscribe((data) => {
                    this.regionCities = data.rows;
                    console.log(this.regionCities);
                  });

                  this.supplierFormData.patchValue({
                    companyName: data.data[0].companyName,
                    vsSupplierCode: data.data[0].vsSupplierCode,
                    vendorCode: data.data[0].mpsVendorCode,
                    firstName: data.data[0].firstName,
                    lastName: data.data[0].lastName,
                    contactPerson: data.data[0].contactPerson,
                    businessRegisterNumber:
                      data.data[0].businessRegistrationNumber,
                    // address: data.data[0].supplierAddress,
                    mobileNumber1: data.data[0].phone1,
                    mobileNumber2: data.data[0].phone2,
                    street: data.data[0].street,
                    city: data.data[0].city.name,
                    region: data.data[0].region.iso,

                    country: data.data[0].country,

                    zipCode: data.data[0].zipcode,
                    website: data.data[0].website,
                  });

                  this.showLoader = false;
                })
                .catch((error) => {
                  // Handle error if the promise rejects
                  console.error('Error fetching supplier data:', error);
                })
                .finally(() => {
                  // Hide loader after completion (whether success or failure)
                  this.showLoader = false;
                });

              this.isValidateTrue = false;
              this.snack.open(
                'This supplier is already in our system. Please go ahead and add their information to the Supplier Portal',
                'OK',
                { duration: 3000, panelClass: 'custom-snack' }
              );
            });
          } else {
            this.emailAddressArray.controls[0]
              .get('emailAddress')
              .setValue(data.data[0].emailAddress1);
            for (let i = 0; i < data.data.length; i++) {
              this.emailData(i, 'Add');
              this.emailAddressArray.controls[i + 1]
                .get('emailAddress')
                .setValue(data.data[i].emailAddress);
            }

            this.supplierFormData.patchValue({
              companyName: data.data[0].companyName,
              vsSupplierCode: data.data[0].vsSupplierCode,
              vendorCode: data.data[0].vendorCode,
              firstName: data.data[0].firstName,
              lastName: data.data[0].lastName,
              contactPerson: data.data[0].contactPerson,
              businessRegisterNumber: data.data[0].businessRegisterNumber,
              mobileNumber1: data.data[0].mobileNumber1,
              mobileNumber2: data.data[0].mobileNumber2,
              // emailAddressArray: [data.data[0].emailAddress1],
              street: data.data[0].street,
              city: data.data[0].city,
              region: data.data[0].region,
              country: data.data[0].country,
              zipCode: data.data[0].zipcode,
              website: data.data[0].website,
            });
            this.isValidateTrue = false;
            this.snack.open(
              'This supplier is already in our system. Please go ahead and add their information to the Supplier Portal',
              'OK',
              { duration: 3000, panelClass: 'custom-snack' }
            );
            // this.showLoader = false;
          }
        }
        this.showLoader = false;
      })
      .catch((err) => {
        console.log(err);
        // this.showLoader = false;
      });
  }

  getCountryFilterKeyDataObservable(pageMeta: Page): Observable<any> {
    pageMeta.serachParam =
      pageMeta.serachParam || pageMeta.serachParam == ''
        ? pageMeta.serachParam
        : this.searchKeyParams;
    this.searchKeyParams = pageMeta.serachParam;
    return this.countryDataWithSearch(pageMeta.serachParam);
  }

  countryDataWithSearch(searchText: any) {
    const term = typeof searchText === 'string' ? searchText : '';
    const regex = new RegExp(term, 'i');
    return new Observable<any>((observer) => {
      // Prefer in-memory list; ensure it's an array to avoid first-load race conditions
      const data: any[] = Array.isArray(this.countryList) ? this.countryList : [];
      const filteredData = data.filter((item: any) => item && regex.test(item.name));
      const dataResult = { rows: filteredData };
      observer.next(dataResult);
      observer.complete();
    });
  }

  getTradingAddressCountryControl(): any {
    return this.supplierFormData.get('country') as FormControl;
  }

  onCountrySelected(value: AutoCompleteDataType) {
    this.supplierFormData.get('region')?.reset();
    this.supplierFormData.get('region')?.setErrors(null);
    this._selectedCountryCode = value.code ? value.code : '';
    this.getRegionFilterKeyDataObservable(this._selectedCountryCode).subscribe(
      (data) => {
        this.countryRegions = data.rows;
      }
    );
  }

  onRegionSelected(value: any) {
    this.supplierFormData.get('city')?.reset();
    this.supplierFormData.get('city')?.setErrors(null);
    // this._selectedRegionCode = value.iso ? value.iso : '';
    this._selectedRegionCode = value;
    this.getCityFilterKeyDataObservable(
      this._selectedRegionCode,
      this._selectedCountryCode
    ).subscribe((data) => {
      this.regionCities = data.rows;
    });
  }

  getRegionFilterKeyDataObservable(countryCode: string) {
    return this.settingsService.getAllRegionsByFliterKeyValue(countryCode);
  }

  getCityFilterKeyDataObservable(regionCode: string, countryCode: string) {
    return this.settingsService.getAllCitiesByFliterKeyValue(
      regionCode,
      countryCode
    );
  }

  copyToClipboard(text: string) {
    const event = (e: ClipboardEvent) => {
      if (e.clipboardData) {
        e.clipboardData.setData('text/plain', text);
        e.preventDefault();
      }
    };
    document.addEventListener('copy', event);
    document.execCommand('copy');
  }
}
